import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
} from '../../UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../UUID.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  ServerFile__toString_impl_4rulpa1zv5xkbnowbd9 as ServerFile__toString_impl_4rulpa,
  ServerFile__hashCode_impl_qj0ii515d8xjm2d7n5l as ServerFile__hashCode_impl_qj0ii5,
} from './ServerFile.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../lightningdb/HasId.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.files.UploadInformation', this, 2);
        tmp0_serialDesc.a1b('uploadUrl', false);
        tmp0_serialDesc.a1b('futureCallToken', false);
        this.u4m_1 = tmp0_serialDesc;
      }
      v4m(encoder, value) {
        var tmp0_desc = this.u4m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.w4m_1);
        tmp1_output.a15(tmp0_desc, 1, value.x4m_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v4m(encoder, value instanceof UploadInformation() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u4m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return UploadInformation().y4m(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.u4m_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var UploadInformationClass;
function UploadInformation() {
  if (UploadInformationClass === VOID) {
    class $ {
      toString() {
        return 'UploadInformation(uploadUrl=' + this.w4m_1 + ', futureCallToken=' + this.x4m_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.w4m_1);
        result = imul(result, 31) + getStringHashCode(this.x4m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UploadInformation()))
          return false;
        if (!(this.w4m_1 === other.w4m_1))
          return false;
        if (!(this.x4m_1 === other.x4m_1))
          return false;
        return true;
      }
      static y4m(seen0, uploadUrl, futureCallToken, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().u4m_1);
        }
        var $this = createThis(this);
        $this.w4m_1 = uploadUrl;
        $this.x4m_1 = futureCallToken;
        return $this;
      }
    }
    initMetadataForClass($, 'UploadInformation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    UploadInformationClass = $;
  }
  return UploadInformationClass;
}
function UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie() {
  var tmp = getKClass(UUID());
  var tmp_0 = DeferToContextualUuidSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie_0() {
  var tmp = getKClass(ServerFile());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, null, tmp$ret$2);
}
function UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie_1() {
  var tmp = getKClass(Instant());
  var tmp_0 = InstantIso8601Serializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w35_1 = [tmp_1, tmp_3, lazy(tmp_4, UploadForNextRequest$Companion$$childSerializers$_anonymous__pwkqie_1)];
      }
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.files.UploadForNextRequest', this, 3);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('file', false);
        tmp0_serialDesc.a1b('expires', true);
        this.z4m_1 = tmp0_serialDesc;
      }
      a4n(encoder, value) {
        var tmp0_desc = this.z4m_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().w35_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.d36_1.equals(Companion_getInstance().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, tmp2_cached[0].f2(), value.d36_1);
        }
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), new (ServerFile())(value.e36_1));
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp_0 = get_default(Companion_instance).b1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
          tmp = !value.f36_1.equals(tmp_0.s26(tmp$ret$1));
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 2, tmp2_cached[2].f2(), value.f36_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a4n(encoder, value instanceof UploadForNextRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z4m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_2().w35_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp = tmp8_cached[1].f2();
          var tmp_0 = tmp5_local1;
          var tmp_1 = tmp7_input.x13(tmp0_desc, 1, tmp, tmp_0 == null ? null : new (ServerFile())(tmp_0));
          tmp5_local1 = tmp_1 == null ? null : tmp_1.l2n_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_2 = tmp8_cached[1].f2();
                var tmp_3 = tmp5_local1;
                var tmp_4 = tmp7_input.x13(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ServerFile())(tmp_3));
                tmp5_local1 = tmp_4 == null ? null : tmp_4.l2n_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.x13(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return UploadForNextRequest().b4n(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.z4m_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_2().w35_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].f2(), tmp0_cached[1].f2(), tmp0_cached[2].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var UploadForNextRequestClass;
function UploadForNextRequest() {
  if (UploadForNextRequestClass === VOID) {
    class $ {
      constructor(_id, file, expires) {
        Companion_getInstance_2();
        _id = _id === VOID ? Companion_getInstance().k2p() : _id;
        var tmp;
        if (expires === VOID) {
          // Inline function 'com.lightningkite.now' call
          var tmp_0 = get_default(Companion_instance).b1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
          tmp = tmp_0.s26(tmp$ret$1);
        } else {
          tmp = expires;
        }
        expires = tmp;
        this.d36_1 = _id;
        this.e36_1 = file;
        this.f36_1 = expires;
      }
      f40() {
        return this.d36_1;
      }
      c4n(_id, file, expires) {
        return new (UploadForNextRequest())(_id, file, expires);
      }
      h36(_id, file, expires, $super) {
        _id = _id === VOID ? this.d36_1 : _id;
        file = file === VOID ? this.e36_1 : file;
        expires = expires === VOID ? this.f36_1 : expires;
        return $super === VOID ? this.c4n(_id, file, expires) : $super.c4n.call(this, _id, new (ServerFile())(file), expires);
      }
      toString() {
        return 'UploadForNextRequest(_id=' + this.d36_1.toString() + ', file=' + ServerFile__toString_impl_4rulpa(this.e36_1) + ', expires=' + this.f36_1.toString() + ')';
      }
      hashCode() {
        var result = this.d36_1.hashCode();
        result = imul(result, 31) + ServerFile__hashCode_impl_qj0ii5(this.e36_1) | 0;
        result = imul(result, 31) + this.f36_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UploadForNextRequest()))
          return false;
        if (!this.d36_1.equals(other.d36_1))
          return false;
        if (!(this.e36_1 === other.e36_1))
          return false;
        if (!this.f36_1.equals(other.f36_1))
          return false;
        return true;
      }
      static b4n(seen0, _id, file, expires, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_0().z4m_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.d36_1 = Companion_getInstance().k2p();
        else
          $this.d36_1 = _id;
        $this.e36_1 = file;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          var tmp_0 = get_default(Companion_instance).b1m();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration(15, DurationUnit_MINUTES_getInstance());
          tmp.f36_1 = tmp_0.s26(tmp$ret$1);
        } else
          $this.f36_1 = expires;
        return $this;
      }
    }
    initMetadataForClass($, 'UploadForNextRequest', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_0});
    UploadForNextRequestClass = $;
  }
  return UploadForNextRequestClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  UploadForNextRequest as UploadForNextRequest3ny2xmglqmyrv,
  Companion_getInstance_2 as Companion_getInstance173agu3fofr81,
  Companion_instance_0 as Companion_instance3dz2aen8k3fc7,
};
//endregion

//# sourceMappingURL=UploadEarlyEndpointModels.mjs.map
